import type { CommonStreamingErrorName } from './Adapter/StreamingPlayerAdapter';
import type { AntStreamingErrorName } from './Adapter/AntStreamingPlayerAdapter/AntStreamingPlayerAdapter';
import type { YanHauStreamingErrorName } from './Adapter/YanHauStreamingPlayerAdapter/YanHauStreamingPlayerAdapter';
import type { MediaMTXStreamingErrorName } from './Adapter/MediaMTXStreamingPlayerAdapter/MediaMTXPlayerAdapter';
import type { HlsStreamingErrorName } from './Adapter/HlsStreamingPlayerAdapter/HlsStreamingPlayerAdapter';

type StreamingErrorName =
    | CommonStreamingErrorName
    | MediaMTXStreamingErrorName
    | HlsStreamingErrorName
    | AntStreamingErrorName
    | YanHauStreamingErrorName;

export default class StreamingError {
    private declare _token: string;
    constructor(
        public readonly name: StreamingErrorName,
        public readonly additionalInfo?: any,
    ) {}
}
